module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "chart-section.0f29c508.png";